<template>
    <nav v-if="sections.length" class="summary-section-menu" aria-label="Summary sections">
        <span class="summary-section-menu-label">Jump to</span>
        <div class="summary-section-menu-links">
            <a v-for="section in sections" :key="section.id" :href="`#${section.id}`" @click.prevent="scrollToSection(section.id)">
                {{ section.label }}
            </a>
        </div>
    </nav>
</template>

<script setup>
defineProps({
    sections: { type: Array, default: () => [] },
})

// In-page anchors resolve against <base href="/">, so scroll directly.
const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' })
}
</script>

<style scoped>
.summary-section-menu {
    position: sticky;
    top: 0;
    z-index: 2;
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 0 0 20px;
    padding: 8px 10px;
    border: 1px solid #dbe3ed;
    border-radius: 8px;
    background: #fff;
    box-shadow: 0 2px 8px rgb(15 23 42 / 8%);
}

.summary-section-menu-label {
    flex: 0 0 auto;
    color: #475569;
    font-size: 0.75rem;
    font-weight: 700;
}

.summary-section-menu-links {
    display: flex;
    min-width: 0;
    gap: 6px;
    overflow-x: auto;
    scrollbar-width: thin;
}

.summary-section-menu a {
    flex: 0 0 auto;
    padding: 4px 8px;
    border-radius: 5px;
    background: #f1f5f9;
    color: #334155;
    font-size: 0.74rem;
    text-decoration: none;
    white-space: nowrap;
}

.summary-section-menu a:hover,
.summary-section-menu a:focus-visible {
    background: #e0f2fe;
    color: #075985;
}

.summary-section-menu a:focus-visible {
    outline: 2px solid #0284c7;
    outline-offset: 2px;
}

@media (max-width: 600px) {
    .summary-section-menu {
        align-items: flex-start;
        flex-direction: column;
        gap: 5px;
    }

    .summary-section-menu-links {
        width: 100%;
    }
}
</style>